import React from "react";
import Navbar from "../components/sub-comp/Navbar.jsx";
import Footer from "../components/sub-comp/MainFooter.jsx";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";

const JrMediaProductions = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="mid-desktop-page">

      <section className="py-16 bg-gradient-to-r from-custom-pink to-purple-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">
            JR Media Productions
          </h1>
          <p className="text-lg sm:text-xl max-w-3xl mx-auto mb-6">
            Professional media services for events, marketing, and campus life.
          </p>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            What We Offer
          </h2>
          <p className="text-gray-700 mb-4">
            JR Media Productions supports the institute with basic photo and
            video coverage for events, marketing content, and simple
            promotional materials. The goal is to keep things practical and
            easy to manage while still looking professional.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-2 mb-8">
            <li>Event photo and video coverage</li>
            <li>Short promotional clips for web and social media</li>
            <li>Simple editing and basic motion graphics</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-800 mb-3">
            How to Request Media Support
          </h3>
          <p className="text-gray-700 mb-6">
            For now, all media requests can be handled manually. Use the
            contact page to reach the team with basic details about your
            event or project.
          </p>

          <a
            href="/contact"
            className="inline-block bg-custom-pink text-white px-6 py-3 rounded-lg font-semibold hover:bg-gold transition-colors duration-300"
          >
            Contact Media Team
          </a>
        </div>
      </section>

      </div>

      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default JrMediaProductions;


